<template>
	<div>
		<el-date-picker   v-model="newDateRange" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy年MM月dd 日" value-format="yyyy-MM-dd"> </el-date-picker>
	</div>
</template>

<script>
	/**
	 * 封装的日期选择组件
	 */
	export default {
		model: {
			prop: 'dateRange',
			event: 'change',
		},
		props: {
			dateRange: {
				required: true,
			},
			/**
			 * 选项。
			 */
			pickerOptions: {
				type: Object,
				required: false,
				default: function() {
					return {
						shortcuts: [
							{
								text: '最近一周',
								onClick(picker) {
									const end = new Date()
									const start = new Date()
									start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
									picker.$emit('pick', [start, end])
								},
							},
							{
								text: '最近一个月',
								onClick(picker) {
									const end = new Date()
									const start = new Date()
									start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
									picker.$emit('pick', [start, end])
								},
							},
							{
								text: '最近三个月',
								onClick(picker) {
									const end = new Date()
									const start = new Date()
									start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
									picker.$emit('pick', [start, end])
								},
							},
						],
					}
				},
			},
		},
		data() {
			return {
				newDateRange: this.dateRange,
			}
		},
		watch: {
			newDateRange(newVal) {
				this.$emit('change', newVal)
			},
		},
		methods: {
			ds(){
				this.$emit("changeDate")
			},
			onPick(maxDate, minDate) {
				this.$emit('pick', { maxDate, minDate })
			},
		},
	}
</script>

<style></style>
